<template>
    <div>
        <card-header title="Edit Survey Question" icon="fa-pencil"/>

        <card-body>
            <rmc-question-form :question="question"/>
        </card-body>

        <card-footer class="pt-3 pb-3">
            <div class="columns">
                <div class="column">
                    <b-button type="is-warning is-outlined" size="is-small" @click="deleteQuestion"><i class="far fa-trash-alt"></i><span class="ml-2" v-if="confirmDelete">Delete Question?</span></b-button>
                </div>
                <div class="column has-text-right">
                    <b-button
                        type="is-primary"
                        size="is-small"
                        @click="submit"
                        :disabled="!question.title || !question.type"
                    ><i class="fas fa-check mr-2"></i>Save Question
                    </b-button>
                </div>
            </div>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardFooter from "@/TIER/components/CardFooter";
    import RmcQuestionForm from "./QuestionForm";

    import {client as http} from '@/http_client';

    export default {
        components: {RmcQuestionForm, CardFooter, CardToolbar, CardBody, CardHeader},
        props: ['card', 'props'],
        data() {
            return {
                question: {},
                confirmDelete: false,
                dirty: null
            };
        },
        methods: {
            loadQuestion: function() {
                this.$emit('loading', true);
                http.get('rmc/sessions/' + this.props.sessionId + '/survey/' + this.props.questionId, {force: true}).then(response => {
                    this.question = response.data;
                    this.question.options = (this.question.options) ? JSON.parse(this.question.options) : [];
                    this.$emit('loading', false);
                }).catch(err => {

                });
            },
            submit: function() {
                http.put('rmc/sessions/' + this.props.sessionId + '/survey/' + this.props.questionId, this.question, {force: true}).then(response => {
                    this.$reloadCard('rmc-session-survey-questions', {sessionId: this.props.sessionId});
                    this.$saveAlert(false);
                    this.$closeCard(this.card);
                }).catch(err => {
                    window.alert('An error occurred while saving the question.');
                    this.$emit('loading', false);
                });
            },
            deleteQuestion() {
                if (this.confirmDelete) {
                    this.$emit('loading', true);

                    http.delete('rmc/sessions/' + this.props.sessionId + '/survey/' + this.props.questionId).then(response => {
                        this.$reloadCard('rmc-session-survey-questions', {sessionId: this.props.sessionId});
                        this.$saveAlert(false);
                        this.$closeCard(this.card);
                    }).catch(err => {

                    });
                } else {
                    this.confirmDelete = true;
                    setTimeout(() => {
                        this.confirmDelete = false;
                    }, 3000);
                }
            }
        },
        watch: {
            'props.questionId': function() {
                this.dirty = null;
                this.loadQuestion();
            },
            'question': {
                deep: true,
                handler: function() {
                    this.dirty = (this.dirty !== null);
                    if (!this.$TIER.saveAlert.active && this.dirty)
                        this.$saveAlert(true, 'Are you done editing this question? Unsaved changes will be lost.');
                }
            }
        },
        mounted() {
            this.loadQuestion();
        }
    };
</script>
